<template>
 <div class="resource-companyProfile-technicalSupport">
  <div class="resource-companyProfile-technicalSupport-title technicalSupport_box">技术专利</div>
  <div class="resource-companyProfile-technicalSupport-technical">
   <div v-for="item in technical" :key="item.rowId"
    class="resource-companyProfile-technicalSupport-technical-item technicalSupport_box">
    <!-- <span class="resource-companyProfile-technicalSupport-technical-item-num">{{ item.number1b920048 }}</span> -->
    <count-to v-if="numVis" class="resource-companyProfile-technicalSupport-technical-item-num" :startVal="0"
     :endVal="item.number1b920048" decimals="0" :duration="3000"></count-to>
    <span class="resource-companyProfile-technicalSupport-technical-item-title">{{ item.input988275a1 }}</span>
   </div>
  </div>
  <div class="resource-companyProfile-technicalSupport-zhengshu technicalSupport_box">
   <div class="resource-companyProfile-technicalSupport-zhengshu-one">
    <div style="height: 48%;  ">
     <a-image width="100%" :src="zhengshu1" />
    </div>
    <div style="height: 48%;">
     <a-image width="100%" :src="zhengshu2" />
    </div>
   </div>
   <div class="resource-companyProfile-technicalSupport-zhengshu-item" v-for="item in topImgList" :key="item.rowId">
    <a-image width="100%" :src="getImgUrl(item)" />
   </div>
  </div>
  <div class="resource-companyProfile-technicalSupport-zhengshu-buttom technicalSupport_box">
   <!-- <div class="resource-companyProfile-technicalSupport-zhengshu-buttom-item" v-for="item in bottomImgList"
    :key="item.rowId">
    <a-image width="100%" height="100%" :src="getImgUrl(item)" />
   </div> -->

   <a-image :preview="{ visible: false }" :previewMask="true" width="100%" height="100%" :src="zhengshu_bg"
    @click="visible = true" />
   <div style="display: none">
    <a-image-preview-group :preview="{ visible, onVisibleChange: vis => (visible = vis) }">
     <a-image v-for="item in bottomImgList" :key="item.rowId" :src="getImgUrl(item)" />
    </a-image-preview-group>
   </div>
  </div>
 </div>
 <div class="resource-companyProfile-technicalSupport-mobile">
  <div class="resource-companyProfile-technicalSupport-title technicalSupport_box">技术专利</div>
  <div class="resource-companyProfile-technicalSupport-mobile-technical">
   <div v-for="item in technical" :key="item.rowId"
    class="resource-companyProfile-technicalSupport-mobile-technical-item technicalSupport_box">
    <!-- <span class="resource-companyProfile-technicalSupport-technical-item-num">{{ item.number1b920048 }}</span> -->
    <count-to v-if="numVis" class="resource-companyProfile-technicalSupport-technical-item-num" :startVal="0"
     :endVal="item.number1b920048" decimals="0" :duration="3000"></count-to>
    <span class="resource-companyProfile-technicalSupport-technical-item-title">{{ item.input988275a1 }}</span>
   </div>
  </div>
  <div class="resource-companyProfile-technicalSupport-zhengshu-mobile technicalSupport_box">
   <div class="resource-companyProfile-technicalSupport-zhengshu-one-mobile">
    <div style="height: 48%; ">
     <a-image width="100%" height="100%" :src="zhengshu1" />
    </div>
    <div style="height: 48%;">
     <a-image width="100%" height="100%" :src="zhengshu2" />
    </div>
   </div>
   <div class="resource-companyProfile-technicalSupport-zhengshu-item-mobile" v-for="item in topImgList"
    :key="item.rowId">
    <a-image width="100%" height="100%" :src="getImgUrl(item)" />
   </div>
  </div>
  <div class="resource-companyProfile-technicalSupport-zhengshu-buttom-mobile">
   <a-image class="technicalSupport_box" v-for="item in bottomImgList" :key="item.rowId" :src="getImgUrl(item)" />
  </div>
 </div>
</template>

<script setup>

import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import zhengshu1 from '@/assets/image/companyProfile/zhengshu1.png'
import zhengshu2 from '@/assets/image/companyProfile/zhengshu2.png'
import zhengshu_bg from '@/assets/image/companyProfile/zhengshu_bg.png'
import { CountTo } from 'vue3-count-to';

import ScrollReveal from 'scrollreveal'
const dataInfo = ref(null)
const technical = ref(null)
const visible = ref(false)
const numVis = ref(false)

const topImgList = ref([])
const bottomImgList = ref([])


const getData = async () => {

 let _params = {
  page: 1,
  pageSize: 10,
  worksheetId: "6805abb0ec5e343d1c982655",
  sortField: "number91f457d6",
  isAsc: true
 }
 const _res = await getFilterList(_params)
 if (_res.code === 200 && _res.data && _res.data.length > 0) {
  technical.value = _res.data
 }
 let params = {
  page: 1,
  pageSize: 100,
  worksheetId: "681b090c515de26d77272f2d",
  sortField: "number125c5784",
  isAsc: true
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  topImgList.value = res.data
 }
 let _params_ = {
  page: 1,
  pageSize: 100,
  worksheetId: "681b0c8a515de26d77273b43",
  sortField: "number125c5784",
  isAsc: true
 }
 const _res_ = await getFilterList(_params_)
 if (_res_.code === 200 && _res_.data && _res_.data.length > 0) {
  bottomImgList.value = _res_.data
 }


}
const getImgUrl = (item) => {
 if (item['picture-upload0d55f6fe'] && item['picture-upload0d55f6fe'].length > 0) {
  return item['picture-upload0d55f6fe'][0].url
 } else {
  return ""

 }
}
const _getImgUrl = (item) => {
 if (item['picture-upload0d55f6fe'] && item['picture-upload0d55f6fe'].length > 0) {
  return item['picture-upload0d55f6fe'][0].url
 } else {
  return ""

 }
}
onMounted(async () => {
 await getData()
 const sr = ScrollReveal({
  distance: '50px',
  duration: 1000,
  delay: 300,

 })

 // 为每个元素配置不同的动画
 sr.reveal(".technicalSupport_box", {
  beforeReveal: (el) => {
   numVis.value = true
   el.classList.add('animate__fadeInUp')
  },
 })
})

</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .resource-companyProfile-technicalSupport {
  display: none !important;
 }

 .resource-companyProfile-technicalSupport-mobile {
  display: block;
 }
}

@media screen and (min-width: 800px) {
 .resource-companyProfile-technicalSupport {
  display: block !important;
 }

 .resource-companyProfile-technicalSupport-mobile {
  display: none;
 }
}

.resource-companyProfile-technicalSupport {
 width: 100%;
 height: 100%;
 padding-left: 18%;
 padding-right: 18%;
}

.resource-companyProfile-technicalSupport-mobile {
 width: 100%;
 height: 100%;
}

.resource-companyProfile-technicalSupport-technical {
 width: 100%;
 height: 60px;
 display: flex;
 justify-content: center;
 align-items: center;
 margin: 50px 0;
}

.resource-companyProfile-technicalSupport-mobile-technical {
 width: 100%;
 height: 60px;
 display: flex;
 justify-content: center;
 align-items: center;
 margin: 50px 0;
}

.resource-companyProfile-technicalSupport-title {
 width: 100%;
 font-size: 36px;
 font-family: 'PuHuiTi';
 margin-top: 40px;
 margin-bottom: 20px;
 display: flex;
 justify-content: center;
 color: rgba(51, 51, 51, 1);
}

.resource-companyProfile-technicalSupport-technical-item {
 display: flex;
 flex-direction: column;
 align-items: center;
 padding: 0 60px;
 border-left: 1px solid rgba(51, 51, 51, 1);
 border-right: 1px solid rgba(51, 51, 51, 1);
}

.resource-companyProfile-technicalSupport-mobile-technical-item {
 display: flex;
 flex-direction: column;
 align-items: center;
 margin: 0 10px;
}

.resource-companyProfile-technicalSupport-technical-item:nth-child(2) {
 border-left: none;
 border-right: none;
}

.resource-companyProfile-technicalSupport-technical-item-num {
 font-size: 40px;
 font-family: 'PuHuiTi';
 font-weight: 500;
 color: rgba(32, 129, 235, 1);
}

.resource-companyProfile-technicalSupport-technical-item-title {
 font-size: 16px;
 font-family: 'PuHuiTi';
 font-weight: 400;
 color: #333333;
}

.resource-companyProfile-technicalSupport-zhengshu {
 width: 100%;
 height: 100%;
 display: flex;
 justify-content: space-between;
 margin-top: 40px;
 margin-bottom: 30px;
}

.resource-companyProfile-technicalSupport-zhengshu-mobile {
 width: 100%;
 height: 100%;
 display: flex;
 justify-content: space-between;
 flex-wrap: wrap;
 padding: 0 5px;

}

.resource-companyProfile-technicalSupport-zhengshu-item {


 width: 150px;
 // flex-shrink: 0;
 margin-left: 10px;
}

.resource-companyProfile-technicalSupport-zhengshu-item-mobile {
 width: 15rem;
 height: 130px;

 flex-shrink: 0;
 margin-bottom: 10px;
}

.resource-companyProfile-technicalSupport-zhengshu-one {

 width: 150px;
 display: flex;
 flex-direction: column;
 justify-content: space-between;
 align-items: center;

}

.resource-companyProfile-technicalSupport-zhengshu-one-mobile {
 width: 17rem;
 height: 130px;
 display: flex;
 flex-direction: column;
 justify-content: space-between;
 align-items: center;
 margin-bottom: 20px;
}

.resource-companyProfile-technicalSupport-zhengshu-buttom {
 width: 100%;

 display: flex;
 margin-top: 20px;
 margin-bottom: 30px;

}

.resource-companyProfile-technicalSupport-zhengshu-buttom-item {
 width: 150px;
 height: 220px;
 flex-shrink: 0;
}

.resource-companyProfile-technicalSupport-zhengshu-buttom-item:nth-child(1) {
 transform: translateX(0);
}

.resource-companyProfile-technicalSupport-zhengshu-buttom-item {
 transform: translateX(-50px);
}

::v-deep(.ant-image-mask) {
 background-color: transparent !important;
}

.resource-companyProfile-technicalSupport-zhengshu-buttom-mobile {
 display: grid;
 justify-content: space-between;
 grid-template-columns: repeat(auto-fill, 85px);
 grid-gap: 0px;
 padding: 0 5px;
}
</style>